<template>
    <div class="px-3">
        <div aria-describedby="descriptionHelp">
            <person-component :person="person"
                              :class="model.fieldCode"
                              :allowAnonymous="allowAnonymous"
                              :requiredIdentification="requiredIdentification"
                              :validateUniqueIdNumber="validateUniqueIdNumber"
                              :validateEgn="validateEgn"
                              :isProfileDetails="details"
                              :profile-data="profileData" />
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
    </div>
</template>

<script>
    import PersonComponent from '../person/Person';
    import {
        DynamicRegisterPersonModel,
        EditorComponentModel,
        Person
    } from '../../models/models';
    import { mapGetters } from 'vuex';

    export default
    {
        inject: ['$validator'],
        props: {
            model: {
                type: EditorComponentModel
            },
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            requiredIdentification: {
                default: true,
                type: Boolean
            },
            validateUniqueIdNumber: {
                type: Boolean,
                default: true
            },
            validateEgn: {
                type: Boolean,
                default: false
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            PersonComponent
        },
        data() {
            return {
                person: new Person()
            };
        },
        mounted() {
            let hasSavedPerson = false;
            try {
                console.log(this.$parent.$parent.$parent.$parent)
                this.$parent.$parent.$parent.$parent.people.forEach(p => {
                    if (p.fieldId === this.model.id) {
                        this.person = p.person;
                        hasSavedPerson = true;
                    }
                });

                if (!hasSavedPerson) {
                    this.$parent.$parent.$parent.$parent.people.push(
                        new DynamicRegisterPersonModel({
                            fieldId: this.model.id,
                            person: this.person
                        })
                    );
                }
            } catch (error) {
                console.error(
                    '"this.$parent.$parent.people" не работи в components/dynamic/Person.vue'
                );
            }

            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        }
    };
</script>
